module.exports = __webpack_public_path__ + "static/media/object-group.0fabe49e.svg";